import { render, staticRenderFns } from "./review_tab_files.vue?vue&type=template&id=5c019c62&scoped=true&"
import script from "./review_tab_files.vue?vue&type=script&lang=js&"
export * from "./review_tab_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c019c62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c019c62')) {
      api.createRecord('5c019c62', component.options)
    } else {
      api.reload('5c019c62', component.options)
    }
    module.hot.accept("./review_tab_files.vue?vue&type=template&id=5c019c62&scoped=true&", function () {
      api.rerender('5c019c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/reviews/item/tabs/review_tab_files.vue"
export default component.exports